
export const newsArchiveURIs = {
  home: "/news",
  page: "/news/page/",
  category: "/archives/category/",
};

